import React, { useState } from "react";
import { capitalize } from "utils/strings";
import { ReactComponent as CloseFAQIcon } from "images/svg/faq-close.svg";
import { ReactComponent as OpenFAQIcon } from "images/svg/faq-open.svg";
import "../styles.scss";

const CommunityFaqs = ({ faqs }) => {
  const [openFaq, setOpenFaq] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);

  const toggleFaq = (index) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  const indexOfLastFaq = currentPage * itemsPerPage;
  const indexOfFirstFaq = indexOfLastFaq - itemsPerPage;
  const currentFaqs = faqs?.slice(indexOfFirstFaq, indexOfLastFaq) || [];
  const totalPages = Math.ceil((faqs?.length || 0) / itemsPerPage);

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setOpenFaq(null);

  };

  const handleItemsPerPageChange = (e) => {
    const newItemsPerPage = parseInt(e.target.value);
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  return (
    <div className="faq-container">
      <div className="faq-list">
        {currentFaqs.length > 0 ? (
          currentFaqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openFaq === index ? 'open' : ''}`}
            >
              <div className="faq-question" onClick={() => toggleFaq(index)}>
                <span>{capitalize(faq.question)}</span>
                <button className="faq-toggle-btn">
                  {openFaq === index ? 
                    <CloseFAQIcon className="faq-icon" /> : 
                    <OpenFAQIcon className="faq-icon" />
                  }
                </button>
              </div>
              {openFaq === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className="faq-empty">
            <p>No FAQs matching search term at the moment</p>
          </div>
        )}
      </div>

      {faqs?.length > 3 && (
        <div className="faq-pagination">
          <div className="pagination-controls">
            <span className="pagination-text">Show</span>
            <select 
              className="pagination-select" 
              value={itemsPerPage}
              onChange={handleItemsPerPageChange}
            >
              <option value="3">3</option>
              <option value="5">5</option>
              <option value="10">10</option>
            </select>
            <span className="pagination-text">Entries</span>
          </div>

          <div className="pagination-buttons">
            <button 
              className="pagination-btn" 
              disabled={currentPage === 1}
              onClick={() => handlePageChange(1)}
            >
              «
            </button>
            <button 
              className="pagination-btn" 
              disabled={currentPage === 1}
              onClick={() => handlePageChange(currentPage - 1)}
            >
              ‹
            </button>
            
            {pageNumbers.map(number => (
              <button
                key={number}
                className={`pagination-btn ${currentPage === number ? 'active' : ''}`}
                onClick={() => handlePageChange(number)}
              >
                {number}
              </button>
            ))}
            
            <button 
              className="pagination-btn" 
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(currentPage + 1)}
            >
              ›
            </button>
            <button 
              className="pagination-btn" 
              disabled={currentPage === totalPages}
              onClick={() => handlePageChange(totalPages)}
            >
              »
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default CommunityFaqs;